import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "../../lib/api";
import { CLUBS } from "../../data/clubs";
import { Switch } from "../ui/switch";
import { CLUB_ROOMS_CHANNEL } from "../../hooks/useClubRoomsOn";

// Demo mode: switch a club's lobby tile (logo + link to their saved room) on while you show them, off when you're done.
export const ClubRoomsPanel = () => {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/api/admin/club-rooms").then((r) => setOn(r.data.on)).catch((e) => toast.error(errorMessage(e))); }, []);
  const flip = async (slug, v) => {
    try {
      const r = await api.patch("/api/admin/club-rooms", { slug, on: v }); setOn(r.data.on);
      if ("BroadcastChannel" in window) {   // lobby tabs in this browser switch at once
        const bc = new BroadcastChannel(CLUB_ROOMS_CHANNEL);
        bc.postMessage(Object.keys(r.data.on).filter((k) => r.data.on[k])); bc.close();
      } toast.success(`${slug.toUpperCase()} ${v ? "is showing in the lobby" : "is back to coming soon"}`); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <div className="gold-card rounded-2xl p-6 flex flex-col gap-4" data-testid="admin-club-rooms">
      <div>
        <div className="font-display text-xl gold-text">Club rooms — demo mode</div>
        <p className="text-xs text-slate-400 mt-1">Every room stays saved. Switched off, its lobby box shows "Coming soon" and its room link is closed to players; switch it on to show a club its room. Club admins can always reach their own admin page.</p>
      </div>
      {on === null ? <span className="text-xs text-slate-500">Loading…</span> : CLUBS.map((c) => (
        <div key={c.slug} className="flex items-center gap-4 border-t border-amber-400/10 pt-3" data-testid={`admin-club-room-${c.slug}`}>
          <span className="w-28 h-11 rounded-lg flex items-center justify-center px-2" style={{ background: c.tileBg || "rgba(255,255,255,0.95)" }}>
            <img src={c.tileLogo || c.tile} alt="" className="max-h-full max-w-full object-contain" />
          </span>
          <div className="flex-1 flex flex-col">
            <span className="text-sm text-amber-50">{c.name}</span>
            <span className="text-[11px] text-slate-500">playersroom.au/{c.slug}</span>
          </div>
          <span className={`text-[10px] uppercase tracking-[0.25em] ${on[c.slug] ? "text-emerald-300" : "text-slate-500"}`} data-testid={`admin-club-room-state-${c.slug}`}>{on[c.slug] ? "Showing" : "Coming soon"}</span>
          <Switch checked={!!on[c.slug]} onCheckedChange={(v) => flip(c.slug, v)} data-testid={`admin-club-room-switch-${c.slug}`} />
        </div>
      ))}
    </div>
  );
};
